/**
 * @overview Prevents entire mosaic card to be clickable on
 * desktop/tablet. Only the button will be clickable.
 * @module mosaic-card.js
*/

const mosaicLinks = document.querySelectorAll('.js-mosaic-card__link');
const mosaicLinksArray = [];
let mobile;

if (mosaicLinks) {
  if (window.innerWidth < 769) {
    mobile = true;
  }

  // We need to listen for mobile sizes so that the entire
  // area can be clickable and only the button tablet/desktop.
  const resizeListener = () => {
    window.addEventListener(`resize`, debounce(() => {
      if (window.innerWidth < 769) {
        mobile = true;
      }
      else {
        mobile = false;
      }
    }, 250));
  };

  resizeListener();

  for (let i = 0; i < mosaicLinks.length; i++) {
    mosaicLinksArray.push(mosaicLinks[i]);
  }

  Array.prototype.forEach.call(mosaicLinks, function (el) {
    const mosaicButton = el.querySelector('.js-mosaic-card__call-to-action');

    // If not mobile size, prevent entire area to be clickable and only
    // the button.
    el.addEventListener('click', function(e) {
      if (e.target.closest('a') === this && e.target !== mosaicButton && !mobile) {
        e.preventDefault();
      }
    });
  });
}
